import { render, staticRenderFns } from "./Oneclick.vue?vue&type=template&id=abd3c9ec&scoped=true&"
import script from "./Oneclick.vue?vue&type=script&lang=js&"
export * from "./Oneclick.vue?vue&type=script&lang=js&"
import style0 from "./Oneclick.vue?vue&type=style&index=0&id=abd3c9ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd3c9ec",
  null
  
)

export default component.exports